import TermlyCookieBanner from '@m/components/TermlyCookieBanner/TermlyCookieBanner';
import Providers from '@m/providers';

import Portal from './Portal';

export default function App() {
  return (
    <Providers>
      <TermlyCookieBanner />
      <Portal />
    </Providers>
  );
}
